import { useMemo } from 'react';

import { MaintenanceListTableBriefBodyTitleValue } from '@/components/sections/service/maintenance-list/table/brief/body/title-value';
import { Box } from '@/components/shared/layout/box';
import { Container } from '@/components/shared/layout/container';
import { CHECK_8_SYSTEM } from '@/contents/lcv/parts';

interface MaintenanceListTableBriefBodyPrivilegesProps {
  privileges?: string[];
}

export const MaintenanceListTableBriefBodyPrivileges = (
  props: MaintenanceListTableBriefBodyPrivilegesProps
) => {
  const getPartTooltipCustom = (title: string) => {
    if (title.includes('8 ระบบสำคัญ')) {
      return CHECK_8_SYSTEM;
    }
    return undefined;
  };

  const uniquePrivileges = useMemo(
    () =>
      props.privileges?.filter(
        (item, index) => props.privileges?.indexOf(item) === index
      ),
    [props.privileges]
  );

  return (
    <>
      {uniquePrivileges?.map((privilege, index) => (
        <Box
          key={`maintenance_privileges${index}${privilege}`}
          paddingY="3"
          border="b-1"
          borderColor="gray300"
        >
          <Container size="sm">
            <MaintenanceListTableBriefBodyTitleValue
              label={privilege}
              partTooltipData={getPartTooltipCustom(privilege)}
            />
          </Container>
        </Box>
      ))}
    </>
  );
};

MaintenanceListTableBriefBodyPrivileges.displayName =
  'SectionMaintenanceListTableBriefBodyPrivileges';
